const menuWrapper = document.querySelector(".webx-animated-menu-wrapper");
const hamburgerMenu = document.querySelector(".webx-hamburger-menu-animated");
const menuContent = document.querySelector(".webx-animated-menu-content");
const iconMenu = document.querySelector(".webx-menu-icon");
const closeIcon = document.querySelector(".webx-close-icon");
const backButton = document.querySelector(".webx-back-button");

let originalCloseIconHTML = closeIcon ? closeIcon.innerHTML : "";
let isInBackButtonMode = false;

menuWrapper.addEventListener("click", (e) => {
	if (isInBackButtonMode) {
		e.preventDefault(); // Prevent the menuWrapper's default behavior
		return;
	}
	if (hamburgerMenu) {
		hamburgerMenu.classList.toggle("animate");
	}

	if (iconMenu) {
		iconMenu.classList.toggle("hidden");
		closeIcon.classList.toggle("hidden");
	}

	menuContent.classList.toggle("open");

	if (menuContent.classList.contains("open")) {
		document.body.style.overflow = "hidden"; // Disable scrolling
	} else {
		document.body.style.overflow = ""; // Enable scrolling
	}
});

const toggleButton = document.querySelectorAll(
	".wp-block-navigation-submenu__toggle",
);

toggleButton.forEach((button) => {
	button.addEventListener("click", function () {
		const allSubmenuContainers = document.querySelectorAll(
			".wp-block-navigation__submenu-container",
		);

		allSubmenuContainers.forEach((submenu) =>
			submenu.classList.remove("active"),
		);

		const submenuContainer = this.closest("li").querySelector(
			".wp-block-navigation__submenu-container",
		);

		submenuContainer.classList.add("active");
	});
});

document.addEventListener("DOMContentLoaded", function () {
	if (window.innerWidth <= 768) {
		function adjustSubmenuPosition() {
			const menuItems = document.querySelectorAll(
				".wp-block-navigation-item.has-child",
			);

			if (!menuItems.length) return;

			const firstMenuItem = menuItems[0];
			const firstParentRect = firstMenuItem.getBoundingClientRect();

			menuItems.forEach(function (menuItem) {
				const submenu = menuItem.querySelector(
					".wp-block-navigation__submenu-container",
				);

				if (!submenu) return;

				const nextNav = submenu.closest(".wp-block-navigation");

				if (nextNav && nextNav.classList.contains("wp-block-navigation")) {
					const nextNavHeight = nextNav.getBoundingClientRect().height;
					submenu.style.height = `${nextNavHeight + 10}px`;
				}

				submenu.style.position = "fixed";

				submenu.style.top = `${firstParentRect.top}px`;
				submenu.style.left = `${firstParentRect.left}px`;
			});
		}

		adjustSubmenuPosition();

		window.addEventListener("resize", adjustSubmenuPosition);

		const menuItems = document.querySelectorAll(
			".wp-block-navigation-item.has-child",
		);
		menuItems.forEach(function (menuItem) {
			menuItem.addEventListener("transitionend", function () {
				adjustSubmenuPosition();
			});
		});

		const parentLinks = document.querySelectorAll(
			".wp-block-navigation-submenu.has-child",
		);

		parentLinks.forEach(function (parentLink) {
			const submenuContainerToShow = parentLink.querySelector(
				".wp-block-navigation__submenu-container",
			);
			parentLink.addEventListener("click", function (event) {
				if (closeIcon) {
					const newBackButtonSVG = `
                        <svg id="icon-back-btn" class="icon-back-btn" width="100%" height="100%" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                            <g transform="matrix(1,0,0,1,-6.17706,-0.0350328)">
                                <path d="M12.389,15L27.354,0.035L29.965,2.646L17.611,15L29.965,27.354L27.354,29.965L12.389,15Z"></path>
                            </g>
                        </svg>
                    `;
					closeIcon.innerHTML = newBackButtonSVG;
					closeIcon.classList.remove("webx-close-icon");
					closeIcon.classList.add("webx-back-button");
					isInBackButtonMode = true;

					closeIcon.addEventListener("click", function (e) {
						e.preventDefault();

						const submenuContainer = parentLink.querySelector(
							".wp-block-navigation__submenu-container",
						);
						if (submenuContainer) {
							submenuContainer.style.display = "none";
						}

						setTimeout(() => {
							closeIcon.classList.remove("webx-back-button");
							closeIcon.classList.add("webx-close-icon");

							// Restore the original HTML of the close icon
							closeIcon.innerHTML = originalCloseIconHTML;

							// Reset the flag to disable back button mode
							isInBackButtonMode = false;

							if (submenuContainerToShow) {
								submenuContainerToShow.style.display = "block"; // Reset to block
							}
						}, 10);
					});
				}

				if (hamburgerMenu) {
					isInBackButtonMode = true;
					hamburgerMenu.classList.add("back-button");
					hamburgerMenu.classList.remove("animate");

					const backButtonClickHandler = function (e) {
						e.preventDefault();

						const submenuContainer = parentLink.querySelector(
							".wp-block-navigation__submenu-container",
						);
						if (submenuContainer) {
							submenuContainer.style.display = "none";
						}

						setTimeout(() => {
							hamburgerMenu.classList.remove("back-button");
							hamburgerMenu.classList.add("animate");
							isInBackButtonMode = false;
							if (submenuContainerToShow) {
								submenuContainerToShow.style.display = "block"; // Reset to block
							}

							// Remove the back-button-specific event listener
							hamburgerMenu.removeEventListener(
								"click",
								backButtonClickHandler,
							);
						}, 10);
					};

					// Add the back-button-specific event listener
					hamburgerMenu.addEventListener("click", backButtonClickHandler);
				}
			});
		});
	}
});
